function show(container) {
  container.classList.add('active')
  container.style.height = 'auto'
  const height = container.clientHeight + 3 + 'px'
  container.style.height = '0px'
  setTimeout(() => {
    container.style.height = height
  }, 0)
}

function hide(container) {
  container.style.height = '0px'
  container.addEventListener(
    'transitionend',
    () => {
      container.classList.remove('active')
    },
    { once: true }
  )
}
export const ease = {
  show,
  hide
}
